export const dependeciesHelper = [
  {
    id: 1,
    type: 'Presidencia',
    abbreviation: 'CAPRES',
    dependence: 'Presidencia de la República',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 2,
    type: 'Ministerio',
    abbreviation: 'MH',
    dependence: 'Ministerio de Hacienda',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 3,
    type: 'Ministerio',
    abbreviation: 'MTPS',
    dependence: 'Ministerio de Trabajo y Previsión Social',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 4,
    type: 'Ministerio',
    abbreviation: 'MOPT',
    dependence: 'Ministerio de Obras Públicas y de Transporte',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 5,
    type: 'Ministerio',
    abbreviation: 'MINSAL',
    dependence: 'Ministerio de Salud',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 6,
    type: 'Ministerio',
    abbreviation: 'MAG',
    dependence: 'Ministerio de Agricultura y Ganadería',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 7,
    type: 'Ministerio',
    abbreviation: 'MDN',
    dependence: 'Ministerio de Defensa Nacional',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 8,
    type: 'Ministerio',
    abbreviation: 'MARN',
    dependence: 'Ministerio de Medio Ambiente y Recursos Naturales',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 9,
    type: 'Ministerio',
    abbreviation: 'MICULTURA',
    dependence: 'Ministerio de Cultura',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 10,
    type: 'Ministerio',
    abbreviation: 'MINEC',
    dependence: 'Ministerio de Economía',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 11,
    type: 'Ministerio',
    abbreviation: 'MITUR',
    dependence: 'Ministerio de Turismo',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 12,
    type: 'Ministerio',
    abbreviation: 'MINEDUCYT',
    dependence: 'Ministerio de Educación, Ciencia y Tecnología',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 13,
    type: 'Ministerio',
    abbreviation: 'RREE',
    dependence: 'Ministerio de Relaciones Exteriories',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 14,
    type: 'Ministerio',
    abbreviation: 'MIGOBDT',
    dependence: 'Ministerio de Gobernación y Desarrollo Territorial',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 15,
    type: 'Ministerio',
    abbreviation: 'MJSP',
    dependence: 'Ministerio de Justicia y Seguridad Pública',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 16,
    type: 'Ministerio',
    abbreviation: 'MINDEL',
    dependence: 'Ministerio de Desarrollo Local',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 17,
    type: 'Ministerio',
    abbreviation: 'MIVI',
    dependence: 'Ministerio de Vivienda',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 18,
    type: 'Viceministerio',
    abbreviation: 'VMT',
    dependence: 'Viceministerio de Transporte',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 19,
    type: 'Dirección',
    abbreviation: 'DGA',
    dependence: 'Dirección General de Aduanas',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 20,
    type: 'Dirección',
    abbreviation: 'DGEHM',
    dependence: 'Dirección General de Energía, Hidrocarburos y Minas',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 21,
    type: 'Superintendencia',
    abbreviation: 'SRS',
    dependence: 'Superintendencia de Regulación Sanitaria',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 22,
    type: 'Dirección',
    abbreviation: 'DGME',
    dependence: 'Dirección General de Migración y Extranjeria',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 23,
    type: 'Dirección',
    abbreviation: 'BOMBEROS',
    dependence: 'Cuerpo de Bomberos de El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 24,
    type: 'Dirección',
    abbreviation: 'DINAC',
    dependence: 'Dirección Nacional de Compras',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 25,
    type: 'Dirección',
    abbreviation: 'DOM',
    dependence: 'Dirección Nacional de Obras Municipales',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 26,
    type: 'Dirección',
    abbreviation: 'DGCP',
    dependence: 'Dirección General de Centros Penales',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 27,
    type: 'Dirección',
    abbreviation: 'INTREGRACIÓN',
    dependence: 'Dirección de Integración',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 28,
    type: 'Fondo',
    abbreviation: 'FONAES',
    dependence: 'Fondo Ambiental de El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 29,
    type: 'Fondo',
    abbreviation: 'FINET',
    dependence: 'Fondo de Inversión Nacional en Electrificación y Telefonía',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 30,
    type: 'Fondo',
    abbreviation: 'FSV',
    dependence: 'Fondo Social para la Vivienda',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 31,
    type: 'Fondo',
    abbreviation: 'FOVIAL',
    dependence: 'Fondo de Conservación Vial El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 32,
    type: 'Fondo',
    abbreviation: 'FOSALUD',
    dependence: 'Fondo Solidario para la Salud',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 33,
    type: 'Fondo',
    abbreviation: 'FOPROLYD',
    dependence: 'Fondo de Protección de Lisiados y Discapacitados a Consecuencia del Conflicto Armado',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 34,
    type: 'Fondo',
    abbreviation: 'FONAT',
    dependence: 'Fondo para la Atención a las Víctimas de Accidentes de Tránsito',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 35,
    type: 'Fondo',
    abbreviation: 'FANTEL',
    dependence: 'Fondo Especial de los Recursos Provenientes de la Privatización de ANTEL',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 36,
    type: 'Fondo',
    abbreviation: 'FOSOFAMILIA',
    dependence: 'Fondo Solidario para la Familia Microempresa',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 37,
    type: 'Fondo',
    abbreviation: 'FOSEP',
    dependence: 'Fondo Salvadoreño para Estudios de Preinversión',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 38,
    type: 'Fondo',
    abbreviation: 'FONAVIPO',
    dependence: 'Fondo Nacional de Vivienda Popular',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 39,
    type: 'Hospitales',
    abbreviation: '-',
    dependence: 'Hospitales Nacionales',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 40,
    type: 'Autónoma',
    abbreviation: 'LNB',
    dependence: 'Lotería Nacional de Beneficencia',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 41,
    type: 'Autónoma',
    abbreviation: 'CAMUDASAL',
    dependence: 'Caja Mutual del Abogado de El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 42,
    type: 'Autónoma',
    abbreviation: 'CAJA MUTUAL MINED',
    dependence: 'Caja Mutual de los Empleados del Ministerio de Educación',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 43,
    type: 'Autónoma',
    abbreviation: 'ASA',
    dependence: 'Autoridad Salvadoreña del Agua',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 44,
    type: 'Autónoma',
    abbreviation: 'AMP',
    dependence: 'Autoridad Marítima Portuaria',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 45,
    type: 'Autónoma',
    abbreviation: 'AAC',
    dependence: 'Autoridad Marítima Portuaria',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 46,
    type: 'Autónoma',
    abbreviation: 'CIFCO',
    dependence: 'Centro Internacional de Ferias y Convenciones',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 47,
    type: 'Autónoma',
    abbreviation: 'RNPN',
    dependence: 'Registro Nacional de Personas Naturales',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 48,
    type: 'Autónoma',
    abbreviation: 'IN',
    dependence: 'Imprenta Nacional',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 49,
    type: 'Autónoma',
    abbreviation: 'CNR',
    dependence: 'Centro Nacional de Registros',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 50,
    type: 'Autónoma',
    abbreviation: 'OSA',
    dependence: 'Organismo Salvadoreño de Acreditación',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 51,
    type: 'Autónoma',
    abbreviation: 'CIM',
    dependence: 'Centro de Investigaciones de Metrología',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 52,
    type: 'Autónoma',
    abbreviation: 'OSN',
    dependence: 'Organismo Salvadoreño de Normalización',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 53,
    type: 'Autónoma',
    abbreviation: 'OSARTEC',
    dependence: 'Organismo Salvadoreño de Reglamentación Técnica',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 54,
    type: 'Autónoma',
    abbreviation: 'CORSAIN',
    dependence: 'Cooperación Salvadoreña de Inversiones',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 55,
    type: 'Autónoma',
    abbreviation: 'CORSATUR',
    dependence: 'Corporación Salvadoreña de Turismo',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 56,
    type: 'Autónoma',
    abbreviation: 'OPA',
    dependence: 'Oficina para Adopciones',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 57,
    type: 'Autónoma',
    abbreviation: 'PROTECCIÓN CIVIL',
    dependence: 'Protección Civil',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 58,
    type: 'Autónoma',
    abbreviation: 'OMR',
    dependence: 'Protección Civil',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 59,
    type: 'Autónoma',
    abbreviation: 'CONNA',
    dependence: 'Consejo Nacional de la Niñez y la Adoloscencia',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 60,
    type: 'Autónoma',
    abbreviation: 'DEFENSORÍA',
    dependence: 'Defensoría del Consumidor',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 61,
    type: 'Autónoma',
    abbreviation: 'ENA',
    dependence: 'Escuela Nacional de Agricultura',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 62,
    type: 'Autónoma',
    abbreviation: 'ANSP',
    dependence: 'Academia Nacional de Seguridad Pública',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 63,
    type: 'Autónoma',
    abbreviation: 'CENTA',
    dependence: 'Centro Agropecuario de Tecnología Agropecuaria y Forestal',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 64,
    type: 'Autónoma',
    abbreviation: 'INVEST',
    dependence: 'Agencia de Promoción de Inversión y Exportaciones de El Salvador (INVEST)',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 65,
    type: 'Autónoma',
    abbreviation: 'ESCO',
    dependence: 'Agencia Salvadoreña para la Cooperación Internacional',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 66,
    type: 'Autónoma',
    abbreviation: 'CORREOS',
    dependence: 'Dirección General de Correos',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 67,
    type: 'Autónoma',
    abbreviation: 'ANDA',
    dependence: 'Administración Nacional de Acueductos y Alcantarillados',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 68,
    type: 'Autónoma',
    abbreviation: 'CONACYT',
    dependence: 'Consejo Nacional de Ciencia y Tecnología',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 69,
    type: 'Autónoma',
    abbreviation: 'CNE',
    dependence: 'Consejo Nacional de Energía',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 70,
    type: 'Autónoma',
    abbreviation: 'CONAPINA',
    dependence: 'Consejo Nacional de la Primera Infancia, Niñez y Adolescencia',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 71,
    type: 'Autónoma',
    abbreviation: 'CONSAA',
    dependence: 'Consejo Salvadoreño de la Agroindustria Azucarera',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 72,
    type: 'Autónoma',
    abbreviation: 'CSC',
    dependence: 'Consejo Salvadoreño del Café',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 73,
    type: 'Autónoma',
    abbreviation: 'CEFAFA',
    dependence: 'Centro Farmacéutico de la Fuerza Armada',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 74,
    type: 'Autónoma',
    abbreviation: 'CONAIPD',
    dependence: 'Consejo Nacional para la Inclusión de Personas con Discapacidad',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 75,
    type: 'Autónoma',
    abbreviation: 'CSSP',
    dependence: 'Consejo Superior de Salud Pública',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 76,
    type: 'Autónoma',
    abbreviation: 'BCR',
    dependence: 'Banco Central de Reserva',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 77,
    type: 'Autónoma',
    abbreviation: 'CONAMYPE',
    dependence: 'Comisión Nacional de la Micro y Pequeña Empresa',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 78,
    type: 'Autónoma',
    abbreviation: 'CVPCPA',
    dependence: 'Consejo de Vigilancia y de la Profesión de Contaduría Pública y Auditoría',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 79,
    type: 'Autónoma',
    abbreviation: 'CONAB',
    dependence: 'Consejo Nacional de la Administración de Bienes',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 80,
    type: 'Autónoma',
    abbreviation: 'CNC',
    dependence: 'Consejo Nacional de Calidad',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 81,
    type: 'Autónoma',
    abbreviation: 'PNC',
    dependence: 'Policía Nacional Civil',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 82,
    type: 'Autónoma',
    abbreviation: 'UES',
    dependence: 'Universidad Nacional de El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 83,
    type: 'Comisión',
    abbreviation: 'CEPA',
    dependence: 'Comisión Ejecutiva Portuaria Autónoma',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 84,
    type: 'Comisión',
    abbreviation: 'CEL',
    dependence: 'Comisión Ejecutiva Hidroeléctrica del Río Lempa',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 85,
    type: 'Instituto',
    abbreviation: 'ISSS',
    dependence: 'Instituto Salvadoreño del Seguro Social',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 86,
    type: 'Instituto',
    abbreviation: 'ISDEMU',
    dependence: 'Instituto Salvadoreño para el Desarrollo de la Mujer',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 87,
    type: 'Instituto',
    abbreviation: 'ISTU',
    dependence: 'Instituto Salvadoreño de Turismo',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 88,
    type: 'Instituto',
    abbreviation: 'ILP',
    dependence: 'Instituto de Legalización de la Propiedad',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 89,
    type: 'Instituto',
    abbreviation: 'ICJ',
    dependence: 'Instituto Crecer Juntos',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 90,
    type: 'Instituto',
    abbreviation: 'INABVE',
    dependence: 'Instituto Administrador de los Beneficiarios de los Veteranos y Excombatientes',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 91,
    type: 'Instituto',
    abbreviation: 'IBA',
    dependence: 'Instituto de Bienestar Animal',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 92,
    type: 'Instituto',
    abbreviation: 'ISTA',
    dependence: 'Instituto Salvadoreño de Transformación Agraria',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 93,
    type: 'Instituto',
    abbreviation: 'IGD',
    dependence: 'Instituto de Garantía de Depósitos',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 94,
    type: 'Instituto',
    abbreviation: 'INDES',
    dependence: 'Instituto Nacional de los Deportes de El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 95,
    type: 'Instituto',
    abbreviation: 'IEESFORD',
    dependence: 'Instituto Especializado de Educación Superior para la Formación Diplomática',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 96,
    type: 'Instituto',
    abbreviation: 'ISBM',
    dependence: 'Instituto Salvadoreño de Bienestar Magisterial',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 97,
    type: 'Instituto',
    abbreviation: 'ISDEM',
    dependence: 'Instituto Salvadoreño de Desarrollo Municipal',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 98,
    type: 'Instituto',
    abbreviation: 'INSAFORP',
    dependence: 'Instituto Salvadoreño de Formación Profesional',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 99,
    type: 'Instituto',
    abbreviation: 'ISP',
    dependence: 'Instituto Salvadoreño de Pensiones',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 100,
    type: 'Instituto',
    abbreviation: 'ISRI',
    dependence: 'Instituto Salvadoreño de Rehabilitación Integral',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 101,
    type: 'Instituto',
    abbreviation: 'IPSFA',
    dependence: 'Instituto de Previsión Social de la Fuerza Armada',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 102,
    type: 'Instituto',
    abbreviation: 'INSAFOCOOP',
    dependence: 'Instituto Salvadoreño de Fomento Cooperativo',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 103,
    type: 'Inspectoría',
    abbreviation: 'IGSP',
    dependence: 'Inspectoría General de Seguridad Pública',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 103,
    type: 'Banco',
    abbreviation: 'BANDESAL',
    dependence: 'Banco de Desarrollo de El Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 104,
    type: 'Banco',
    abbreviation: 'BFA',
    dependence: 'Banco de Fomento Agropecuario',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 105,
    type: 'Banco',
    abbreviation: 'BH',
    dependence: 'Banco Hipotecario',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 106,
    type: 'Superintendencia',
    abbreviation: 'SIGET',
    dependence: 'Superintendencia General de Electricidad y Telecomunicacioneso',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 107,
    type: 'Superintendencia',
    abbreviation: 'SC',
    dependence: 'Superintendencia de Competencia',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 108,
    type: 'Superintendencia',
    abbreviation: 'SOM',
    dependence: 'Superintendencia de Obligaciones Mercantiles',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 109,
    type: 'Superintendencia',
    abbreviation: 'SSF',
    dependence: 'Superintendencia del Sistema Financiero',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 110,
    type: 'Secretaría, CAPRES',
    abbreviation: 'SI',
    dependence: 'Secretaría de Innovación',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 111,
    type: 'Secretaría',
    abbreviation: 'SINTEGRA',
    dependence: 'Secretaría de Integración',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 112,
    type: 'Órgano Legislativo',
    abbreviation: 'Asamblea',
    dependence: 'Asamblea Legislativa de la República',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 113,
    type: 'Órgano Judicial',
    abbreviation: 'CSJ',
    dependence: 'Corte Suprema de Justicia',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 114,
    type: 'Órgano Judicial',
    abbreviation: 'CNJ',
    dependence: 'Consejo Nacional de Judicatura',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 115,
    type: 'Órgano Judicial',
    abbreviation: '-',
    dependence: 'Juzgados de Paz, Tribunales y Juzgados de Primera Instancia, Cámaras de Segunda Instancia, Centros Judiciales Integradosa',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 116,
    type: 'Otras dependencias del Estado',
    abbreviation: 'FGR',
    dependence: 'Fiscalía General de la República',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 117,
    type: 'Otras dependencias del Estado',
    abbreviation: 'IAIP',
    dependence: 'Instituto de Acceso a la Información Pública',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 118,
    type: 'Otras dependencias del Estado',
    abbreviation: 'OPAMSS',
    dependence: 'Oficina de Planificación del Área Metropolitana de San Salvador',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 119,
    type: 'Otras dependencias del Estado',
    abbreviation: 'PGR',
    dependence: 'Procuraduría General de la República',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 120,
    type: 'Otras dependencias del Estado',
    abbreviation: 'PDDH',
    dependence: 'Procuraduría para la Defensa de los Derechos Humanos',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 121,
    type: 'Otras dependencias del Estado',
    abbreviation: 'TGE',
    dependence: 'Tribunal de Ética Gubernamental',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 122,
    type: 'Otras dependencias del Estado',
    abbreviation: 'TSE',
    dependence: 'Tribunal Supremo Electoral',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 123,
    type: 'Otras dependencias del Estado',
    abbreviation: 'TSC',
    dependence: 'Tribunal de Servicio Civil',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 124,
    type: 'Otras dependencias del Estado',
    abbreviation: 'UTE',
    dependence: 'Unidad Técnica Ejecutiva del Sector Justicia',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 125,
    type: 'Otras dependencias del Estado',
    abbreviation: 'CCR',
    dependence: 'Corte de Cuentas de la República',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 126,
    type: 'Municipalidades',
    abbreviation: 'Municipalidades',
    dependence: 'Municipalidades',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 126,
    type: 'Gobernaciones',
    abbreviation: 'Gobernaciones',
    dependence: 'Gobernaciones',
    contact: '',
    format_1: '',
    format_2: ''
  },
  {
    id: 126,
    type: 'Oficinas',
    abbreviation: 'Oficinas',
    dependence: 'Oficinas',
    contact: '',
    format_1: '',
    format_2: ''
  }
];
